import builder from '../builder';
import TimeClockCircle from '../../streamline-icons/light/time-clock-circle.svg';

export default builder('IconTimeClockCircleLight', TimeClockCircle);
